<template>
  <div class="footer_wrapper">
    <div class="top_footer">
      <el-row>
        <el-col :span="8" style="display: flex; align-items: center; justify-content: center">
          <div class="top_fot_left">
            <div class="top_title">越华鹏诚数字科技(山东)有限公司</div>
            <div class="line"></div>
            <div class="top_list">
              <span>企业文化：诚信务实，追求卓越</span>
              <span>创新发展：永续经营，成为危废智能管理领域领导品牌</span>
              <span>经营理念：诚信为本，内外兼修，抓住机遇，挑战未来</span>
              <span>质量方针：质量为先，信誉为重，管理为本，服务为诚</span>
            </div>
            <div class="email_wrap">
              <div class="email_left">
                <input type="text" placeholder="请输入邮箱..." />
              </div>
              <div class="email_right"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="top_fot_mid">
            <div>
              <div class="top_title">关于我们</div>
              <div class="line"></div>
              <div class="top_list" @click="routerPages('/about')">
                <div class="top_list_item">
                  <img src="../assets/right_icon.png" alt="" />公司简介
                </div>
                <div class="top_list_item">
                  <img src="../assets/right_icon.png" alt="" />企业文化
                </div>
                <div class="top_list_item">
                  <img src="../assets/right_icon.png" alt="" />发展历程
                </div>
                <div class="top_list_item">
                  <img src="../assets/right_icon.png" alt="" />荣誉资质
                </div>
              </div>
            </div>
            <div>
              <div class="top_title">产品中心</div>
              <div class="line"></div>
              <div class="top_list">
                <div class="top_list_item" @click="routerPages('/unattended')">
                  <img src="../assets/right_icon.png" alt="" />无人值守危废库
                </div>
                <div class="top_list_item" @click="routerPages('/wasteTerminal')">
                  <img src="../assets/right_icon.png" alt="" />危废终端设备
                </div>
                <div class="top_list_item" @click="routerPages('/digitalize')">
                  <img src="../assets/right_icon.png" alt="" />危废收集数字化管理系统
                </div>
                <div class="top_list_item" @click="routerPages('/intelligent')">
                  <img src="../assets/right_icon.png" alt="" />固体废物全过程智慧化管理
                </div>
              </div>
            </div>
            <div>
              <div class="top_title">快速导航</div>
              <div class="line"></div>
              <div class="top_list">
                <div class="top_list_item" @click="routerPages('/home')">
                  <img src="../assets/right_icon.png" alt="" />首页
                </div>
                <div class="top_list_item" @click="routerPages('/about')">
                  <img src="../assets/right_icon.png" alt="" />关于我们
                </div>
                <div class="top_list_item" @click="routerPages('/unattended')">
                  <img src="../assets/right_icon.png" alt="" />产品中心
                </div>
                <div class="top_list_item" @click="routerPages('/news')">
                  <img src="../assets/right_icon.png" alt="" />资讯中心
                </div>
                <div class="top_list_item" @click="routerPages('/contact')">
                  <img src="../assets/right_icon.png" alt="" />联系我们
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="top_fot_right">
            <div class="right_line"></div>
            <div>
              <div class="top_title">联系我们</div>
              <div class="line"></div>
              <div class="phone_num">4000992980</div>
              <div class="address">
                <span>24小时全天热线为您服务</span>
                <span>地址：山东济宁梁山越华环保产业园产学研基地</span>
              </div>
              <div class="right_img">
                <img src="../assets/wx_icon.png" alt="" />
                <img src="../assets/qq_icon.png" alt="" />
                <img src="../assets/wb_icon.png" alt="" />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="top_footer_phone">
      <div class="top_fot_left" style="padding: 0 25px; box-sizing: border-box">
        <div class="title_wrap">
          <div class="line"></div>
          <div class="top_title">越华鹏诚数字科技(山东)有限公司</div>
        </div>
        <div class="top_list">
          <span>企业文化：诚信务实，追求卓越</span>
          <span>创新发展：永续经营，成为危废智能管理领域领导品牌</span>
          <span>经营理念：诚信为本，内外兼修，抓住机遇，挑战未来</span>
          <span>质量方针：质量为先，信誉为重，管理为本，服务为诚</span>
        </div>
      </div>
      <div class="top_fot_mid" style="padding: 0 25px; box-sizing: border-box">
        <div class="fot_mid_item">
          <div class="title_wrap">
            <div class="line"></div>
            <div class="top_title">关于我们</div>
          </div>
          <div class="top_list" @click="routerPages('/about')" style="
              display: flex;
              flex-direction: row;
              justify-content: space-around;
            ">
            <div class="top_list_item">公司简介</div>
            <div class="top_list_item">企业文化</div>
            <div class="top_list_item">发展历程</div>
            <div class="top_list_item">荣誉资质</div>
          </div>
        </div>
        <div class="fot_mid_item">
          <div class="title_wrap">
            <div class="line"></div>
            <div class="top_title">产品中心</div>
          </div>
          <div class="top_list" style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              flex-wrap: wrap;
            ">
            <div>
              <div class="top_list_item" @click="routerPages('/unattended')">
                无人值守危废库
              </div>
              <div class="top_list_item" @click="routerPages('/digitalize')">
                危废收集数字化管理系统
              </div>
            </div>
            <div>
              <div class="top_list_item" @click="routerPages('/intelligent')">
                固体废物全过程智慧化管理
              </div>
              <div class="top_list_item" @click="routerPages('/wasteTerminal')">
                危废终端设备
              </div>
            </div>
          </div>
        </div>
        <div class="fot_mid_item">
          <div class="title_wrap">
            <div class="line"></div>
            <div class="top_title">快速导航</div>
          </div>
          <div class="top_list" style="
              display: flex;
              flex-direction: row;
              justify-content: space-around;
            ">
            <div class="top_list_item" @click="routerPages('/home')">首页</div>
            <div class="top_list_item" @click="routerPages('/about')">
              关于我们
            </div>
            <div class="top_list_item" @click="routerPages('/unattended')">
              产品中心
            </div>
            <div class="top_list_item" @click="routerPages('/news')">
              资讯中心
            </div>
            <div class="top_list_item" @click="routerPages('/contact')">
              联系我们
            </div>
          </div>
        </div>
      </div>
      <div class="top_fot_right" style="padding: 0 25px; box-sizing: border-box">
        <div>
          <div class="title_wrap">
            <div class="line"></div>
            <div class="top_title">联系我们</div>
          </div>
          <div class="phone_num">4000992980</div>
          <div class="address">
            <span>24小时全天热线为您服务</span>
            <span>地址：山东济宁梁山越华环保产业园产学研基地</span>
          </div>
          <div class="right_img">
            <img src="../assets/wx_icon.png" alt="" />
            <img src="../assets/qq_icon.png" alt="" />
            <img src="../assets/wb_icon.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_footer">
      <span>版权所有&copy;越华鹏诚数字科技(山东)有限公司</span>
      <span>致力于为客户提供危废智能云管理和系统解决方案</span>
      <span>备案号：皖ICP备2023000581号</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    routerPages(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// PC端
@media screen and (min-width: 769px) {
  .footer_wrapper {
    cursor: default;
    background: #000000;
    color: #d5dce7;

    .top_footer_phone {
      display: none;
    }

    .top_footer {
      padding-top: 84px;
      padding-bottom: 37px;

      .top_title {
        font-size: 25px;
        color: #ffffff;
      }

      .line {
        width: 55px;
        height: 2px;
        background-color: #be1420;
        margin-top: 28px;
        margin-bottom: 42px;
      }

      .top_list {
        display: flex;
        flex-direction: column;
        font-size: 17px;
        color: #d5dce7;

        .top_list_item {
          display: flex;
          align-items: center;
          margin-bottom: 43px;
          cursor: pointer;

          img {
            width: 7px;
            height: 12px;
            margin-right: 24px;
          }
        }
      }

      .top_fot_left {
        span {
          margin-bottom: 19px;
        }

        .email_wrap {
          display: flex;
          width: 110%;
          height: 60px;
          border: #be1420 solid 3px;
          margin-top: 50px;

          .email_left {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            input {
              background: none;
              border: none;
              outline: none;
              height: 90%;
              color: #ffffff;
            }
          }

          .email_right {
            width: 25%;
            background: #be1420;
          }
        }
      }

      .top_fot_mid {
        display: flex;
        justify-content: space-around;
      }

      .top_fot_right {
        display: flex;

        .right_line {
          width: 3px;
          height: 430px;
          background-color: #1b2634;
          margin-right: 65px;
        }

        .phone_num {
          font-size: 38px;
          color: #ffffff;
        }

        .address {
          display: flex;
          flex-direction: column;
          font-size: 17px;
          color: #d5dce7;
          margin-top: 41px;
          margin-bottom: 70px;

          span {
            margin-bottom: 13px;
          }
        }

        .right_img {
          img {
            width: 41px;
            height: 41px;
            margin-right: 13px;
          }
        }
      }
    }

    .bottom_footer {
      border-top: #1b2634 solid 1px;
      padding: 37px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      color: #48525c;

      span {
        padding: 0 16px;
      }

      span:nth-child(2) {
        border-right: #46515f solid 2px;
        border-left: #46515f solid 2px;
      }
    }
  }
}

// 移动端
@media screen and (max-width: 768px) {
  .footer_wrapper {
    background: #000000;
    color: #d5dce7;

    .top_footer {
      display: none;
    }

    .top_footer_phone {
      display: flex;
      flex-direction: column;
      padding-top: 84px;
      padding-bottom: 37px;

      .title_wrap {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .top_title {
          font-size: 25px;
          color: #ffffff;
        }

        .line {
          width: 5px;
          height: 35px;
          background-color: #be1420;
          margin-right: 20px;
        }
      }

      .top_list {
        display: flex;
        flex-direction: column;
        font-size: 17px;
        color: #d5dce7;

        .top_list_item {
          margin-bottom: 10px;

          img {
            width: 7px;
            height: 12px;
            margin-right: 24px;
          }
        }
      }

      .top_fot_left {
        span {
          margin-bottom: 19px;
        }

        .email_wrap {
          display: flex;
          width: 110%;
          height: 60px;
          border: #be1420 solid 3px;
          margin-top: 50px;

          .email_left {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            input {
              background: none;
              border: none;
              outline: none;
              height: 90%;
              color: #ffffff;
            }
          }

          .email_right {
            width: 25%;
            background: #be1420;
          }
        }
      }

      .top_fot_mid {
        .fot_mid_item {
          margin-top: 20px;
        }
      }

      .top_fot_right {
        display: flex;

        .phone_num {
          font-size: 38px;
          color: #ffffff;
        }

        .address {
          display: flex;
          flex-direction: column;
          font-size: 17px;
          color: #d5dce7;
          margin-top: 10px;
          margin-bottom: 10px;

          span {
            margin-bottom: 13px;
          }
        }

        .right_img {
          img {
            width: 41px;
            height: 41px;
            margin-right: 13px;
          }
        }
      }
    }

    .bottom_footer {
      border-top: #1b2634 solid 1px;
      padding: 37px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      color: #48525c;

      span {
        padding: 0 16px;
      }
    }
  }
}
</style>
